import { render, staticRenderFns } from "./shouhu-dialog.vue?vue&type=template&id=d6fe343a&scoped=true&"
import script from "./shouhu-dialog.vue?vue&type=script&lang=js&"
export * from "./shouhu-dialog.vue?vue&type=script&lang=js&"
import style0 from "./shouhu-dialog.vue?vue&type=style&index=0&id=d6fe343a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6fe343a",
  null
  
)

export default component.exports